<template>
	<div class="h100">
		<div class='root h100' v-show="!menu">
			<div style="display: flex;flex-wrap:wrap;" class="print applogo">
				<logo class="logos"></logo>
				<p v-for="item in navList" :key="item.value" :class="$style.dnitem" :selected="isNaveSelected(item)"
					@click="navClick(item)" class="showInLarge">{{item.text}}</p>
				<div class="f1"></div>
				<div class="f1 right showInLarge" style="min-width:208px;">
					<!-- <img src="./assets/user.svg" width="18" :class="$style.usericon" class="biggerpic" @click="$router.push('/person');">
        <img src="./assets/heart.svg" width="18" :class="$style.usericon" class="biggerpic"  @click="$router.push('/favorites');"> -->
					<span :class="$style.usericon" class="dib yel"
						@click="$router.push('/person');">{{$t('aperson')}}</span>
					<span v-if="hasToken" :class="$style.usericon" class="dib yel"
						@click="logout">{{$t('alogout')}}</span>
					<!-- <span :class="$style.usericon" class="dib yel"
						@click="$router.push('/favorites');">{{$t('afavorite')}}</span> -->
					<span :class="$style.usericon" class="dib yel"
						@click="$router.push('/interviews');">{{$t('interview1')}}</span>
				</div>
				<el-select v-model="lang" style="width: 82px; margin-top: 10px;" class="showInLarge langIcon">
					<el-option v-for="item in langArr" :key="item.value" :label="item.text" :value="item.value">
					</el-option>
				</el-select>
				<div class="showInSmall cp">
					<div class="dflex fc fcenter h100"><img src="./assets/more.png" width="18" height="18"
							@click="showMenu"></div>
				</div>
			</div>
			<router-view style="min-height: calc(100% - 252px)"></router-view>
			<div class="pr backblack white a1 dflex gray fcenter print" :class="$style.footer"
				style="padding-top: 30px;">
				<img src="./assets/w.png" alt="" :class="$style.w">
				<div style="margin-left: 20px;">
					<p :class="$style.fo1">高菲僱傭有限公司</p>
					<p>GOLDEN WIN EMPLOYMENT AGENCY LTD</p>
					<p :class="$style.fo2">
						<img src="./assets/fb1.png" alt="" :class="$style.fb1" class="cp" @click="goFB">
						<span style="margin: 0px 10px;" class="cp"
							@click="$router.push('/termPersonal')">{{$t('f1')}}</span>
						<span class="cp" @click="$router.push('/termCondition')">{{$t('f2')}}</span>
					</p>
					<p>{{$t('reseve')}}</p>
				</div>
				<!-- <div class="showInLarge">
        <div class="dflex fcenter" style="padding-top:30px;padding-bottom:30px;">
          <ulogo></ulogo>
        </div>
        <div class="fs10 dflex acsb fw300">
          <div v-for="item in companies" :key="item.name" style="width: 182px;">
            <p class="yel fw500" style="padding-left:20px;padding-bottom: 10px;">{{ item.name.toUpperCase() }}{{item.isMain? ($i18n.locale === 'en' ? ' (':'（')+$t('maino')+($i18n.locale === 'en'?')':'）') : ''}}</p>
            <div class="dflex" :style="{height: $i18n.locale ==='en' ? '70px': 'auto'}">
                <i class="el-icon-location" style="padding-top:3px;"></i>
                <div class="pdl10">
                  <p >{{ item.addr }}</p>
                  <p >{{ item.addr1 }}</p>
                </div>
            </div>
            <p class="pt10 dflex">
            <i class="el-icon-phone" style="padding-top:3px;"></i>
            <span class="pdl10" v-if="item.isMain">{{item.person}}{{($i18n.locale === 'en' ? ' (':'（')+$t('director')+($i18n.locale === 'en'?')':'）')}}<span class="pdl10">{{ item.mobile }}</span></span>
            <span class="pdl10" v-else>{{item.phone}} <template v-if="item.phone">/</template>{{$t('m')}} {{item.mobile}}</span>
            </p>
            <p class="pt10 dflex">
              <i class="el-icon-message" style="padding-top:2px;"></i>
                <span class="pdl10">
                    {{ item.email }}
                </span>
            </p>
          </div>
        </div>
        <div class="fs10 print fw300 center" style="padding-top:30px;">
          {{ $t('reseve') }}
        </div>
      </div> -->
				<!-- <div class="showInLarge">
        <div class="dflex fcenter" style="padding-top:30px;padding-bottom:10px;">
        <img src="./assets/slogo.png" style="width:24%;height:15%;">
        </div>
      </div>
      <div class="showInSmall">
        <div class="dflex fcenter" style="padding-top:30px;padding-bottom:10px;">
        <img src="./assets/slogo.png" style="width:74%;height:15%;">
        </div>
      </div>
      <div class="a2">
        <img src="./assets/fb.png" class="cp" width="18" style="vertical-align: -2px;" @click="goFB">
        <img :src="ppurl" class="cp" style="height:10px;padding: 0px 5px;" @click="$router.push('/termPersonal')">
        <img :src="tcurl" class="cp" style="height:8px;vertical-align: 1px;" @click="$router.push('/termCondition')">
      </div> -->
				<!-- <div style="max-width: 400px;">
        <img :src="require('./assets/logo1.png')" contain style="width: 90%">
        <p class="pt10">{{ $t('des') }}</p>
      </div>
      <div v-for="item in companies" :key="item.name" style="margin-left: 20px;width: 250px;">
        <p class="yel fw500" style="padding-left: 17px;">{{ item.name }}</p>
        <p class="pt10">
          <i class="el-icon-location"></i>
          <span class="pdl10">{{ item.addr }}</span>
        </p>
        <p class="pdl10">{{ item.addr1 }}</p>
        <p class="pt10">
          <i class="el-icon-phone"></i>
          <span class="pdl10">{{ item.phone }}</span>
        </p>
        <p class="pt10">
          <img src="./assets/email.svg" width="14">
          <span style="vertical-align: 4px;">
            {{ item.email }}
          </span>
        </p>
      </div> -->
			</div>
			<!-- <div class="backblack white fs12 print" style="padding: 0px 50px 20px 55px;font-weight:300;">
      <p>{{ $t('reseve') }}</p>
    </div> -->
		</div>
		<div v-show="menu"
			style="position: fixed;top:0px;left:0px;right:0px;bottom:0px;padding:10% 10%;font-size: 16px;"
			class="backblack white">
			<div class="dflex" style="margin-bottom:30px;">
				<img v-if="langText == 'EN'" src="./assets/qiu.png" width="15px" height="15px"
					style="margin-top: 3px;float: right;margin-right: 5px;">
				<img v-if="langText== '繁'" src="./assets/qiu.png" width="15px" height="15px"
					style="margin-top: 5px;float: right;margin-right: 5px;">
				<el-dropdown>
					<span class="el-dropdown-link white" style="font-size:18px;">
						{{langText}}<i class="el-icon-arrow-down el-icon--right"></i>
					</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="item in langArr" :key="item.value" :label="item.text"
							:value="item.value">
							<span @click="onLangClick(item)">{{item.text}}</span>
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<div class="f1"></div>
				<i class="el-icon-close" @click="menu = false" style="font-size:18px;"></i>
			</div>
			<div>
				<p v-for="item in navList" :key="item.value" class="white" :class="$style.navItem"
					:selected="isNaveSelected(item)" @click="navClick(item)">{{item.text}}</p>
			</div>
			<div style="padding-top:20px;font-size: 14px;">
				<p @click="navClick({value: 'person'})">{{$t('account1')}}</p>
				<p v-if="hasToken" @click="logout()" style="margin-top:14px;">{{$t('alogout')}}</p>
				<!-- <p @click="navClick({value: 'favorites'})" style="margin-top:14px;">{{$t('favorite11')}}</p> -->
				<p @click="navClick({value: 'interviews'})" style="margin-top:14px;">{{$t('interview1')}}</p>
			</div>
		</div>
		<!-- <let-it-snow v-bind="snowConf" :show="show"></let-it-snow> -->
	</div>
</template>
<script>
	import {
		companies
	} from './data.js';
	import footeren from './assets/footeren.png';
	import footerzh from './assets/footerzh.png';
	import ppen from './assets/pp.png';
	import ppzh from './assets/ppzh.png';
	import tcen from './assets/tc.png';
	import tczh from './assets/tczh.png';

	export default {
		name: 'App',
		data() {
			const langArr = [
				// {value: "zh", text: "繁體中文"},
				{
					value: "zh",
					text: "繁"
				},
				{
					value: "en",
					text: "EN"
				},
				// {value: "en", text: "English"},
			];
			const lang = this.$i18n.locale;
			return {
				snowConf: {
					windPower: 0.8,
					speed: 0.1,
					count: 6,
					size: 8,
					opacity: 0.1,
					images: ['https://www.goldenwin.com.hk/demo/snow.png',
						'https://www.goldenwin.com.hk/demo/sock.png',
						'https://www.goldenwin.com.hk/demo/tree.png'
					]
				},
				show: false,
				langArr,
				lang,
				navList: [{
						text: this.$t('main'),
						value: 'index'
					},
					{
						text: this.$t('search'),
						value: 'search'
					},
					{
						text: this.$t('about'),
						value: 'about'
					},
					{
						text: this.$t('services'),
						value: 'services'
					},
					{
						text: this.$t('price'),
						value: 'price'
					},
					{
						text: this.$t('form'),
						value: 'form'
					},
					{
						text: this.$t('renew'),
						value: 'onlineRenew'
					},
					// {
					// 	text: this.$t('pay'),
					// 	value: 'pay'
					// },
				],
				companies,
				footerurl: this.$i18n.locale === 'en' ? footeren : footerzh,
				ppurl: this.$i18n.locale === 'en' ? ppen : ppzh,
				tcurl: this.$i18n.locale === 'en' ? tcen : tczh,
				menu: false,
				hasToken: this.$service.hasToken(),
			};
		},
		watch: {
			lang(value) {
				this.$i18n.locale = value;
				localStorage.setItem('locale', value);
				location.reload();
			},
		},
		computed: {
			langText() {
				return (this.langArr.find((item) => item.value === this.lang) || {}).text;
			}
		},
		mounted() {
			// this.show = true
		},
		methods: {
			navClick(item) {
				this.$router.push('/' + item.value);
				this.menu = false;
			},
			isNaveSelected(item) {
				return window.location.hash.includes(item.value);
			},
			showMenu() {
				this.menu = true;
			},
			onLangClick(item) {
				this.lang = item.value;
			},
			logout() {
				this.$service.logout();
				window.location.reload();
			},
		}
	};
</script>
<style module>
	.dnitem {
		font-size: 17px;
		color: #f3b707e6;
		min-width: 50px;
		padding: 20px 12px;
		flex-wrap: wrap;
	}

	.dnitem:hover {
		font-size: 20px;
		text-decoration: underline;
	}

	.dnitem:hover,
	.dnitem[selected] {
		color: #f3b707;
		cursor: pointer;
		font-weight: bold;
	}

	.usericon {
		margin-right: 10px;
		margin-top: 20px;
		cursor: pointer;
		/* text */
		font-size: 15px;
	}

	.usericon:hover {
		font-size: 16px;
		text-decoration: underline;
		cursor: pointer;
		font-weight: bold;
	}

	.navItem {
		margin: 16px 0px;
		font-weight: 300;
	}

	.navItem[selected] {
		font-weight: 600;
	}

	.footer {
		font-size: 12px;
		padding-top: 30px;
	}

	.fo1 {
		font-size: 27px;
		letter-spacing: 5px;
		color: white;
	}

	.w {
		width: 50px;
		height: 50px;
	}

	.fb1 {
		width: 17px;
		height: 14px;
		vertical-align: -2px;
	}

	.fo2 {
		margin: 15px 0px;
	}

	@media screen and (max-width: 770px) {
		.w {
			width: 40px;
			height: 40px;
		}

		.fo1 {
			font-size: 20px;
		}
	}
</style>
